<div
	*transloco="let t"
	class="bg-white rounded-lg shadow-lg flex flex-col overflow-hidden border border-black/10"
	style="max-height: 440px"
	(mouseenter)="onPanelEnter()"
	(mouseleave)="onPanelLeave()">
	<div class="flex items-center justify-between px-3.5 pt-2.5 pb-1.5 border-b border-black/10">
		<span class="text-xs font-semibold text-black/50 tracking-wider [font-variant:small-caps]">
			{{ t('sideboard.recentlyVisited') }}
		</span>
		@if (recentRealEstates.length > 0) {
			<button
				type="button"
				class="p-1 rounded text-black/30 hover:text-red-500 hover:bg-red-50 transition-colors"
				[title]="t('sideboard.clearOverview')"
				(click)="onClear()">
				<mat-icon class="!text-[16px] !w-[16px] !h-[16px] !leading-[16px]">delete_outline</mat-icon>
			</button>
		}
	</div>
	<div class="overflow-y-auto">
		@for (re of recentRealEstates; track re.id) {
			<button
				class="recent-row flex items-center gap-3 w-full px-3.5 py-2 border-none cursor-pointer text-left transition-all duration-100 border-b border-b-black/10"
				[class.recent-row--active]="re.id === activeId"
				type="button"
				(click)="selectRealEstate(re)">
				<span class="shrink-0 w-[60px] text-xs font-semibold" style="color: rgba(var(--color-primary), 1)">{{ re.area }}/{{ re.number }}</span>
				<span class="flex flex-col flex-1 min-w-0">
					@if (re.address?.street) {
						<span class="text-sm font-medium text-black truncate">{{ re.address.street }}</span>
					}
					@if (re.address?.zipCode || re.address?.city) {
						<span class="text-xs text-gray-600 truncate">{{ re.address.zipCode }} {{ re.address.city }}</span>
					}
					@if (!re.address) {
						<span class="text-xs text-black/40">&mdash;</span>
					}
				</span>
				<span class="shrink-0 flex flex-col items-end text-[0.65rem] text-black/35 whitespace-nowrap">
					<span>{{ formatDate(re.lastOpened) }}</span>
					<span>{{ formatTime(re.lastOpened) }}</span>
				</span>
			</button>
		} @empty {
			<div class="py-4 px-3.5 text-xs text-black/40 text-center">{{ t('common.noEntries') }}</div>
		}
	</div>
</div>
